import * as TYPE from "../../constants";

const initialState = {
  loading: false,
  divlocs: [],
  defaultValues: [],
  error: "",
};

export const divlocsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.GET_DIVLOCS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TYPE.GET_DIVLOCS_SUCCESS:
      return {
        ...state,
        loading: false,
        divlocs: action.payload.data,
        defaultValues: action.payload.defaultValues,
      };
    case TYPE.GET_DIVLOCS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
